import { getABNVariant } from '~/src/helpers/abn-tests';

const HIDING_LEAD_GENERATION = {
    testName: 'hiding_lead_generation',
    variants: {
        NEW: 'website_without_callback',
        OLD: 'website_with_callback',
    },
};
export const isLeadGenerationHide = (): boolean => getABNVariant(HIDING_LEAD_GENERATION.testName) === HIDING_LEAD_GENERATION.variants.NEW;
